export const AVATAR_HERO =
  "https://static.prod-images.emergentagent.com/jobs/aa60c37a-65a6-4895-bdc9-b9921b1f93eb/images/6879ea930b6f4c478ee7ab7aefdb1a1fb46c46a4cfa248f1325ec5d6318818ed.jpeg";

export const AVATAR_FULL =
  "https://static.prod-images.emergentagent.com/jobs/aa60c37a-65a6-4895-bdc9-b9921b1f93eb/images/9fd8c905272cd4ce8a32601acf5bf27cecde303e53a8f47fbb0ebbde507ccc03.jpeg";

export const TEXTURE_BG =
  "https://images.unsplash.com/photo-1628965882741-570e75becd5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHx0ZXJyYWNvdHRhJTIwYWJzdHJhY3QlMjB0ZXh0dXJlfGVufDB8fHx8MTc4NzQ5MzI0OHww&ixlib=rb-4.1.0&q=85";

export const CONTEXT_SCENE =
  "https://images.pexels.com/photos/27778441/pexels-photo-27778441.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const PERSONA_NAME = "Shabba Robo";

export const CATEGORIES = [
  "General",
  "Personal & Emotional",
  "Relationships",
  "Family",
  "Mental Health",
  "Teamwork & Collaboration",
  "Anything Else",
];
